<p-dropdown
  #dropDown
  class="m-dropdown {{ icon }}"
  [(ngModel)]="value"
  [options]="options"
  [style.width]="width"
  [optionValue]="optionValue"
  [optionLabel]="optionLabel"
  [optionDisabled]="optionDisabled"
  [disabled]="disabled || false"
  [placeholder]="placeholder()"
  [appendTo]="appendTo"
  [resetFilterOnHide]="resetFilterOnHide"
  (onChange)="onChangeRelay($event)"
  [group]="group"
  [filter]="filter"
  [filterBy]="filterBy || 'label'"
  [filterPlaceholder]="filterPlaceholder"
  [styleClass]="styleClass"
  [panelStyleClass]="panelStyleClass + ' m-dropdown-panel'"
  (formControlChange)="onModelChange($event)">
  @if (customTemplate) {
    <ng-template let-option pTemplate="item">
      <ng-container
        *ngTemplateOutlet="
          customTemplate;
          context: { $implicit: option }
        "></ng-container>
    </ng-template>
  }
</p-dropdown>
